import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.639.099a.993.993 0 0 1 1.31.933v10.063a.994.994 0 0 1-1.31.933l-.005-.001-11.585-4.04A1.49 1.49 0 0 1 .051 6.63v-1.1a1.49 1.49 0 0 1 .998-1.4zm-10.61 10.67v-1.13l6.199 2.163a3.186 3.186 0 0 1-6.199-1.034Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const CallToAction = { render };
export {
  CallToAction as default,
  render
};
//# sourceMappingURL=CallToAction.svg.js.map
